import styled from "styled-components";

// @ts-ignore
import {CWBCheckbox} from "cwb-react";

export const Section = styled.div`
  width: 100%;
  margin: 16px 0 8px 0;
  
  &.margin-bottom-none{
    margin-bottom: 0;
  }
`

export const SectionTitle = styled.div`
  font-size: ${p => p.theme['xxs-font-size']};
  font-weight: ${p => p.theme['font-weight-600']};
  color: ${p => p.theme.color} !important;
  line-height: 16px;
`

export const StyledOverlay = styled.div`
  width: 100% !important;
  height: 100% !important;
  position: fixed;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  z-index: 10;
  opacity: 0.5;
  background-color: rgba(0,0,0,0.32);
`

export const StyledBlueBtn = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-size: ${p => p.theme['font-size']};
  font-weight: ${p => p.theme['font-weight-600']};
  color: ${p => p.theme.white} !important;
  outline: 0 !important;
  border: 1px solid ${p => p.theme.btnDarkBlue} !important;
  border-radius: ${p => p.theme.dropDown['border-radius']};
  background: ${p => p.theme.btnDarkBlue};
  box-shadow: none !important;
  padding: 9px 0;
  cursor: pointer;
  &.disabled, &:disabled,
  &.disabled:hover, &:disabled:hover {
    cursor: default;
    border: 1px solid ${p => p.theme['disabled-grey']} !important;
    background: ${p => p.theme['disabled-grey']};
  }
`

export const StyledCheckbox = styled(CWBCheckbox)`
  .icon-cwb-unchecked:before{
    font-size: ${p => p.theme['font-size']};
  }
  .icon-cwb-checked:before{
    font-size: ${p => p.theme['font-size']};
    color: ${p => p.theme.darkBlue};
  }
  &.child-cb {
    margin-left: 40px;
  }
  
  &.small-cb{
    display: flex;
    align-items: center;
    .icon-cwb-unchecked, .icon-cwb-unchecked:before,
    .icon-cwb-checked, .icon-cwb-checked:before{
      font-size: ${p => p.theme['sm-cb-font']};
    }
  }
`

export const StyledInputBox = styled.input`
  height: 32px;
  width: 200px;
  border: ${p => p.theme.border};
  border-radius: 4px;
  background-color:${p => p.theme.white};
  outline: 0 !important;
  box-shadow: none !important;
  padding: 0 8px;
`;

export const StyledInputBox1 = styled.input`
  height: 40px;
  width: 208px;
  border: ${p => p.theme['border-3']};
  border-radius: 4px;
  background-color:${p => p.theme.kiosk.backgroundColor};
  outline: 0 !important;
  box-shadow: none !important;
  padding: 16px;
`;


export const StyledWhiteBtn = styled.button`
  height: 32px;
  width: 92px;
  font-size: ${p => p.theme['xs-font-size']};
  font-weight: ${p => p.theme['font-weight']};
  outline: 0 !important;
  border: ${p => p.theme['border-3']} !important;
  border-radius: ${p => p.theme.dropDown['border-radius']};
  background: ${p => p.theme.white};
  box-shadow: 0 2px 8px 0 rgba(0,0,0,0.08);
  padding: 0 16px;
  cursor: pointer;
  &.disabled, &:disabled
  &.disabled:hover, &:disabled:hover {
    cursor: not-allowed;
    color: ${p => p.theme.white};
    background: ${p => p.theme['disabled-grey']};
  }
`
